module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("14nz6"))).then(() => parcelRequire('hEqeo'));